<template>
  <div id="MainCy" style="width: 100%;height: 100%;"></div>
</template>

<script>
import cytoscape from "../../cytoscape/cytoscape.min.js";
import sbgnStylesheet from "../../cytoscape/bundle.js";
import CytoscapeEdgeEditation from "../../cytoscape/CytoscapeEdgeEditation.js";
import $ from "jquery";
//import routeData from "./jq_process_E2SB_IP.json";

export default {
  name: 'MainCy',
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    showEmptyFlow() {
      const { showOperEdit } = this;

      let objs = []
      objs = [{
        group: 'nodes',
        data: {
          id: 'groupProductNode',
          class: 'compartment',
          label: '',
          operName: 'end',
          clonemarker: false,
          unitsOfInformation: [],
          backgroundColor: '#E1E1E1',
          color: '#fff',
          nodeType: 'end',
          type: 'type1'
          //backgroundImage: 'url(' + require('./img/interior_panel.jpg') + ')'
          },
        position: {
          x: 1200,
          y: 10
        }
      }]
      var sImgUrl = 'interior_panel.jpg'
      if (this.$root.$children[0].$children[0].CurrentPartNo != '') {
        if (this.$root.$children[0].$children[0].CurrentPartEntity.ImageUrl != undefined && this.$root.$children[0].$children[0].CurrentPartEntity.ImageUrl != '') {
          sImgUrl = this.$root.$children[0].$children[0].CurrentPartEntity.ImageUrl
        }
        objs[0].data.label = this.$root.$children[0].$children[0].CurrentPartNo + '\n' + this.$root.$children[0].$children[0].CurrentPartEntity.Description
      }
      try {
        objs[0].data.backgroundImage = 'url(' + require('./img/' + sImgUrl) + ')'
      } catch { }

      var cy = window.cy = cytoscape({
        container: document.getElementById('MainCy'),
        elements: objs,
        layout: { name: 'preset' },
        style: sbgnStylesheet(cytoscape)
      });
      cy.fit()
      cy.pan({ x: 0, y: 300 });
      cy.zoom(1.3)

      var handles = window.handles = new CytoscapeEdgeEditation;
      handles.init(cy);

      handles.registerHandle({
          positionX: "right",
          positionY: "center",
          color: "red",
          type: "default",
          single: false,
          nodeTypeNames: ["type1"]
      });
      handles._editClickHandler = showOperEdit;

    },
    appendOperation(operArgs) {
      const { formatTime, removeEquipByOper, positionEquipByOper } = this;

      let objs = []
      let operNodeId = ''
      if (operArgs.OperDef != undefined) {
        operNodeId = operArgs.OperDef.OperName + formatTime(new Date())
      }
      let nodeX = 500, nodeY = 100
      if (operArgs.OperId != undefined && operArgs.OperId != '') {
        var elements = window.cy.elements()
        for (let i = 0; i < elements.length; i++) {
          if (elements[i].data('id') == operArgs.OperId) {
            elements[i].data('partNo', operArgs.PartNo)
            elements[i].data('textVAlign', operArgs.TextVAlign)
            break
          }
        }

        var position = positionEquipByOper(operArgs.OperId)
        if (position) {
          nodeX = position.x
          nodeY = position.y
        }
        removeEquipByOper(operArgs.OperId)
        operNodeId = operArgs.OperId
      } else {
        // 工序节点
        let objOper = {
          group: 'nodes',
          data: {
            id: operNodeId,
            label: operArgs.OperLabel,
            operName: operArgs.OperDef.OperName,
            partNo: operArgs.PartNo,
            class: 'compartment',
            unitsOfInformation: [],
            backgroundColor: '#E1E1E1',
            color: '#fff',
            textVAlign: operArgs.TextVAlign,
            type: 'type1',
            nodeType: 'operation'
          },
          position: {
            x: nodeX,
            y: nodeY
          }
        }
        objs.push(objOper)
      }
      
      // 设备
      for (let i = 0; i < operArgs.EquipmentList.length; i++) {
        let objEqu = {
          group: 'nodes',
          data: {
            id: operArgs.EquipmentList[i].EquipmentName + formatTime(new Date()),
            label: operArgs.EquipmentList[i].EquipmentName,
            equipmentName: operArgs.EquipmentList[i].EquipmentName,
            equipmentNo: operArgs.EquipmentList[i].EquipmentNo,
            class: 'macromolecule',
            unitsOfInformation: [],
            stateVariables: [],
            w: 150,
            parent: operNodeId,
            operName: operArgs.OperDef.OperName,
            nodeType: 'equipment'
          },
          position: {
            x: nodeX,
            y: nodeY
          }
        }
        objs.push(objEqu)
        nodeY = nodeY + 70
      }

      window.cy.add(objs)
      window.cy.fit()
      window.handles.init(cy);

      handles.registerHandle({
          positionX: "right",
          positionY: "center",
          color: "red",
          type: "default",
          single: false,
          nodeTypeNames: ["type1"]
      });

    },
    loadRouteFlow(flow) {
      const { showEmptyFlow } = this;
      showEmptyFlow()

      let objs = []
      flow.forEach(item => {
        let operStyle = {}
        if (item.OperStyle != '') {
          operStyle = JSON.parse(item.OperStyle)
        }
        // 工艺
        let objNode = {}
        objNode.group = 'nodes'
        objNode.data = {
          id: item.FromOperationCode + '_' + item.ID,
          class: operStyle.class,
          label: item.OperDesc,
          operName: item.FromOperationCode,
          partNo: item.FromPartNo,
          partDesc: item.FromPartDesc,
          clonemarker: false,
          unitsOfInformation: [],
          stateVariables: [],
          backgroundColor: operStyle.backgroundColor,
          color: operStyle.color,
          textVAlign: (operStyle.textVAlign == undefined ? 'top' : operStyle.textVAlign),
          backgroundColor: '#E1E1E1',
          color: '#fff',
          nodeType: 'operation',
          type: 'type1'
        }
        let pos = item.OperLocation.split(',')
        objNode.position = {
          x: parseFloat(pos[0]),
          y: parseFloat(pos[1])
        }
        if (item.FromOperationCode == 'end') {
          objNode.data.nodeType = 'end'
          var sImgUrl = 'interior_panel.jpg'
          if (this.$root.$children[0].$children[0].CurrentPartNo != '') {
            if (this.$root.$children[0].$children[0].CurrentPartEntity.ImageUrl != undefined && this.$root.$children[0].$children[0].CurrentPartEntity.ImageUrl != '') {
              sImgUrl = this.$root.$children[0].$children[0].CurrentPartEntity.ImageUrl
            }
            objNode.data.label = this.$root.$children[0].$children[0].CurrentPartNo + '\n' + this.$root.$children[0].$children[0].CurrentPartEntity.Description
          }
          try {
            objNode.data.backgroundImage = 'url(' + require('./img/' + sImgUrl) + ')'
          } catch { }
        }
        objs.push(objNode)

        // 设备
        let equipList = item.EquipmentList
        let firstNodePos = undefined;
        equipList.forEach(equip => {
          let equStyle = {}
          if (equip.EquStyle != '') {
            equStyle = JSON.parse(equip.EquStyle)
          }
          let objEquipNode = {}
          objEquipNode.group = 'nodes'
          objEquipNode.data = {
            id: equip.EquipmentNo + '_' + equip.ID,
            class: 'macromolecule',
            label: equip.EquipmentName,
            equipmentNo: equip.EquipmentNo,
            equipmentName: equip.EquipmentName,
            clonemarker: false,
            unitsOfInformation: [],
            stateVariables: [],
            backgroundColor: equStyle.backgroundColor,
            color: equStyle.color,
            nodeType: 'equipment',
            w: equStyle.w,
            parent: item.FromOperationCode + '_' + item.ID,
            operName: item.FromOperationCode
          }
          let pos = equip.EquLocation.split(',')
          if (firstNodePos == undefined) {
            firstNodePos = pos
          } else {
            firstNodePos[1] = parseFloat(firstNodePos[1]) + 70
          }
          objEquipNode.position = {
            x: parseFloat(firstNodePos[0]),
            y: parseFloat(firstNodePos[1])
          }
          objs.push(objEquipNode)
        })

        // 连接线
        if (item.ToOperationCode != '') {
          let objTarget
          flow.forEach(x => {
            if (x.FromOperationCode == item.ToOperationCode) {
              objTarget = x
              return
            }
          })
          if (objTarget != undefined) {
            let objEdge = {}
            objEdge.group = 'edges'
            objEdge.data = {
              id: item.FromOperationCode + '_' + item.ID + '_' + objTarget.FromOperationCode + '_' + objTarget.ID,
              source: item.FromOperationCode + '_' + item.ID,
              target: objTarget.FromOperationCode + '_' + objTarget.ID,
              class: 'necessary stimulation'
            }
            objs.push(objEdge)
          }
        }
      })

      var cy = window.cy = cytoscape({
        container: document.getElementById('MainCy'),
        elements: objs,
        layout: { name: 'preset' },
        style: sbgnStylesheet(cytoscape)
      });
      cy.fit()
      window.handles.init(cy);
      handles.registerHandle({
          positionX: "right",
          positionY: "center",
          color: "red",
          type: "default",
          single: false,
          nodeTypeNames: ["type1"]
      });

    },
    formatTime(date) {
      date = new Date()
      var h = date.getHours()
      if (h < 10)
          h = "0" + h;
      var m = date.getMinutes()
      if (m < 10)
          m = "0" + m;
      var s = date.getSeconds();
      if (s < 10)
          s = "0" + s;
      var s = h + '' + m + '' + s;
      return s;
    },
    showOperEdit(operObj) {
      var operName = operObj.data('operName');
      var operId = operObj.data('id');
      var operAttr = {
        PartNo: operObj.data('partNo'),
        OperLabel: operObj.data('label'),
        TextVAlign: operObj.data('textVAlign')
      }
      var operEquList = []
      var elements = window.cy.elements()
      elements.forEach(item => {
        if (item.data('parent') == operId) {
          operEquList.push(item.data('equipmentName'))
        }
      })

      this.$root.$children[0].$children[0].showOperEquipment(operName, operId, operEquList, operAttr)
    },
    removeOperation(nodeId) {
      var objs = {}
      var elements = window.cy.elements()
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].data('id') == nodeId) {
          objs = elements[i]
          break
        }
      }
      window.cy.remove(objs)
    },
    removeEquipByOper(operId) {
      var objs = []
      var elements = window.cy.elements()
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].data('parent') == operId) {
          objs.push(elements[i])
        }
      }
      // remove
      for (let i = 0; i < objs.length; i++) {
        window.cy.remove(objs[i])
      }
    },
    positionEquipByOper(operId) {
      var objs = []
      var elements = window.cy.elements()
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].data('parent') == operId) {
          return elements[i].position()
        }
      }
    },
    getElements() {
      var elements = window.cy.elements()
      return elements
    },
    exportCyJson() {
      console.log(window.cy.json())
    },
    zoomIn() {
      var iZoom = window.cy.zoom()
      iZoom += 0.1
      window.cy.zoom(iZoom)
    },
    zoomOut() {
      var iZoom = window.cy.zoom()
      iZoom -= 0.1
      window.cy.zoom(iZoom)
    },
    zoomFit() {
      window.cy.fit()
    }
  }
};

</script>

<style lang="less" scoped>
#emptop {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
}
.one {
  float: left;
  width: 33%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  text-align: center;
}
.imgdiv {
  width: 100%;
  height: 100%;
  // display: table-cell;
  vertical-align: middle;
  text-align: center;
  display: inline-block;
}
.imgdxx {
  margin: 15px;
  width: 90%;
  height: 90%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}
.zz {
}
</style>
